























































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { dictServe, doublePrevention } from '@/api/installServer';
import publicProp from '@/views/materialsandEquipmentEquipment/publicProp.vue';
import axios from 'axios';
import publishObjectPath from '@/util/configRegistry';
Vue.prototype.$axios = axios;

@Component({
  components: { PagingUnit, CollapseTransition, publicProp },
  mixins: [TableStripe],
})
export default class MaterialsandEquipmentEquipment extends Vue {
  private searchForm: any = {
    type: '', // 演练方式
    search: '', // 模糊搜索
  };

  typeList: any = []; // 应急队伍级别
  private tableLoading = false; // loading...
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  private formShow = true; // 是否显示搜索表单内容
  isShowForm() {
    this.formShow = !this.formShow;
  }

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          doublePrevention.deleteEmergencyMaterials(data.id).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功！');
              this.getTableData();
            } else {
              this.$message.warning('网络错误，请稍后再试！');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      (this.$refs.publicProp as any).showDialog(passValue);
    }
  }

  private onSearch() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private onReset() {
    this.searchForm = {
      type: '',
      search: '',
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getEmergencyMaterials({
        // ...this.queryDataForm,
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        type: this.searchForm.type ? this.searchForm.type : null, // 类型
        search: this.searchForm.search ? this.searchForm.search : null, // 模糊搜索
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.queryDataForm.pageSize = res.data.size;
        } else {
          this.$message.warning('获取数据失败！');
        }
      });
  }

  // 类型 的下拉
  gettypeList() {
    dictServe.getDetailsMapByName('emergencyMaterialsType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.typeList = helpArr;
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  // 下载模板
  downloadTemplet(e: any) {
    const id = e;
    doublePrevention.downResultPdf(id).then((res: any) => {
      // console.log(res)
      const name = '物资装备表模板.xlsx';
      const blob = new Blob([res]);
      const url = window.URL.createObjectURL(blob);
      const aLink = document.createElement('a');
      aLink.style.display = 'none';
      aLink.href = url;
      aLink.setAttribute('download', name);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink); // 下载完成移除元素
      window.URL.revokeObjectURL(url); // 释放掉blob对象
    });
  }

  // 导出数据
  exportData() {
    let needArr: any = []; // 批量导出数据时候存储的id数组
    needArr = [];
    const exportData = (this.$refs.table as any).selection;
    if (exportData.length === 0) {
      this.$message.warning('请先选择要导出的数据！');
    } else {
      exportData.forEach((item: any) => {
        needArr.push(item.id);
      });
      // console.log(needArr);
      this.useInterfaceToExport(needArr);
    }
  }

  useInterfaceToExport(data: any) {
    const serverUrl = publishObjectPath.serverUrl;
    axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    axios.defaults.headers.Authorization = localStorage.getItem('token');
    axios({
      method: 'POST',
      url: serverUrl + '/api/yunnan/emergencyMaterials/export/data', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: data,
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        // console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          // console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '应急物资装备';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        // this.isLoading =  false;
        a.click();
        document.body.removeChild(a);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  created() {
    this.headers.Authorization = localStorage.getItem('token');
    this.getTableData();
    this.gettypeList();
  }

  // 导入表格
  private headers: any = {};
  private fileList: any = [];
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/yunnan/emergencyMaterials/import/data';
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    // console.log(suffix);
    if (suffix === 'xlsx') {
      return true;
    } else {
      this.$message.warning("请检查上传的文件是否是'xlsx'类型的！");
      return false;
    }
  }

  private handleAvatarCardFrontSuccess(file: any) {
    // console.log(file);
    this.$message.success('导入表格成功！');
  }
}
